import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { seasonPassOffer } from "@anjabom/core";
import { completionEvent } from "../lib/completion-analytics";
export function PassPage() {
	const [params] = useSearchParams();
	const [message, setMessage] = useState("");
	const offer = seasonPassOffer;
	const raw = params.get("trigger");
	const trigger =
		raw === "watch_limit" || raw === "poll_limit" ? raw : "settings";
	return (
		<section className="page narrow stack-lg">
			<h1>{offer.name}</h1>
			<p className="lede">
				1년 {offer.priceKrw.toLocaleString("ko-KR")}원 · 한 번 결제 · 자동 갱신
				없음
			</p>
			<p>
				아직 결제는 열지 않았어요. 지금 결제되거나 유료 권한이 생기지 않아요.
			</p>
			<table>
				<caption>무료와 시즌 패스 혜택</caption>
				<thead>
					<tr>
						<th>기능</th>
						<th>무료</th>
						<th>패스가 열리면</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<th>관심 자리 소식</th>
						<td>5개</td>
						<td>50개</td>
					</tr>
					<tr>
						<th>동시 일행 투표</th>
						<td>1개 · 3일</td>
						<td>5개 · 14일</td>
					</tr>
				</tbody>
			</table>
			<p>
				좌석 확인·한 줄 읽기/쓰기·사진·후보 비교·개인 기억·관람 계획·좌석
				지도·카드 이미지·백업·삭제는 계속 무료예요.
			</p>
			<button className="button button-primary" disabled>
				결제 준비 중이에요
			</button>
			<button
				className="button"
				onClick={() => {
					try {
						localStorage.setItem("anjabom.pass-interest.v1", "yes");
						completionEvent("pass_intent", { trigger });
						setMessage(
							"이 기기에 관심을 저장했어요. 외부 알림을 보내거나 연락처를 수집하지 않아요.",
						);
					} catch {
						setMessage("이 기기에 저장하지 못했어요.");
					}
				}}
			>
				열리면 이 기기에서 알려 주기
			</button>
			<p role="status">{message}</p>
			<section>
				<h2>환불·복원·해지 안내</h2>
				<p>
					결제가 열리면 결제 후 7일 안에 혜택을 쓰지 않았을 때 전액 환불을
					제공할 예정이에요. 사용을 시작한 뒤 청약철회가 제한되는 조건은 결제
					전에 다시 안내해요. 자동 갱신이 없어 별도 해지 절차는 없어요.
				</p>
				<p>
					복원은 결제가 열릴 때 같은 토스 계정 또는 웹 결제 영수증으로 확인해요.
					현재는 구매·영수증·복원할 권한이 없어요.
				</p>
				<Link to="/support">환불·구매 문의 경로 확인하기</Link>
				<p>
					운영: 문옵스 · 결제 개시 전 사업자·판매자 필수 정보를 함께 안내해요.
				</p>
			</section>
			<Link to="/settings">무료 기능으로 돌아가기</Link>
		</section>
	);
}
